import React from "react";
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import { userInitial } from '../../actions/';
import Footer from "../../Footer/FooterBottom";
import DashBoardBg from "../../Admin/Question/View/Background/DashBoard/DashBoardBg";
import "./UserControl.css";

class UserControl extends React.Component {
    state = {
        searchQuery: "",
        viewMode: "categorized",
        activeCategory: "all",
        showNotificationsOnly: false
    };

    componentDidMount() {
        window.scrollToPosition("main-dashboard-section");
    }

    renderNotification = count => {
        if (count > 0) {
            if (count > 99) {
                return <span className="badge badge-danger m-2 position-absolute" style={{
                    top: 0,
                    left: 0
                }}>+99</span>
            }
            else {
                return <span className="badge badge-danger m-2 position-absolute" style={{
                    top: 0,
                    left: 0
                }}>{count}</span>
            }
        }
        return "";
    }

    getControlItems = (t, user, notifications, location) => {
        let Schools = 0;
        let mailbox = 0;
        let ErrorReport = 0;
        let WhatsAppUnread = 0;
        if (notifications && notifications.Notification && user.user && user.user.UserType.Id === 1) {
            Schools = notifications.Notification.Schools;
            mailbox = notifications.Notification.Contact;
            ErrorReport = notifications.Notification.ErrorReport;
            WhatsAppUnread = notifications.Notification.WhatsAppUnread || 0;
        }

        const items = [];

        const isAdmin = user.user && user.user.UserType.Id === 1;
        const isParent = user.user && user.user.UserType.Id === 2;
        const isSchool = user.user && user.user.UserType.Id === 3;
        const isTeacher = user.user && user.user.UserType.Id === 4;
        const isStudent = user.user && user.user.UserType.Id === 5;
        const isLoggedIn = !!user.user;

        if (isAdmin) {
            items.push({
                to: "/ControlPanel/Users",
                title: t('Pages.UserControl.users'),
                icon: "fal fa-users",
                category: "admin_users"
            });
            items.push({
                to: "/ControlPanel/Schools",
                title: t('Pages.UserControl.schools'),
                icon: "fal fa-school",
                category: "admin_users"
            });
            items.push({
                to: "/ControlPanel/Schools/Registration",
                title: t('Pages.SchoolsControl.showRegistered'),
                icon: "fal fa-registered",
                category: "admin_users",
                notification: Schools
            });
            items.push({
                to: "/ControlPanel/",
                title: t('Pages.UserControl.Contents'),
                icon: "fal fa-keyboard",
                category: "admin_content"
            });
            items.push({
                to: "/ControlPanel/MailBox",
                title: t('Pages.UserControl.mailbox'),
                icon: "fal fa-mailbox",
                category: "admin_messaging",
                notification: mailbox
            });
            items.push({
                to: "/ControlPanel/SendEmail",
                title: t('Pages.UserControl.SendEmail'),
                icon: "fal fa-paper-plane",
                category: "admin_messaging"
            });
            items.push({
                to: "/ControlPanel/FileManager",
                title: t('Pages.UserControl.FileManager'),
                icon: "fal fa-photo-video",
                category: "admin_content"
            });
            items.push({
                to: "/ControlPanel/Bills",
                title: t('Pages.UserControl.Bills'),
                icon: "fal fa-file-invoice-dollar",
                category: "admin_billing"
            });
            items.push({
                to: "/ControlPanel/ErrorReport",
                title: t('Pages.UserControl.ErrorReport'),
                icon: "fal fa-tools",
                category: "admin_billing",
                notification: ErrorReport
            });
            items.push({
                to: "/ControlPanel/WhatsApp",
                title: t('Pages.UserControl.whatsapp'),
                icon: "fab fa-whatsapp",
                category: "admin_messaging",
                notification: WhatsAppUnread
            });
            items.push({
                to: "/ControlPanel/SMS",
                title: t('Pages.UserControl.sms') || "SMS",
                icon: "fal fa-sms",
                category: "admin_messaging"
            });
            items.push({
                to: "/ControlPanel/Templates",
                title: t('Pages.UserControl.Templates'),
                icon: "fal fa-pencil-ruler",
                category: "admin_content"
            });
            items.push({
                to: "/ControlPanel/Game/Templates",
                title: t('Pages.UserControl.GameTemplates'),
                icon: "fal fa-pencil",
                category: "admin_content"
            });
            items.push({
                to: "/ControlPanel/SearchResult",
                title: t('Pages.UserControl.SearchResult'),
                icon: "fal fa-magnifying-glass",
                category: "admin_content"
            });
            items.push({
                to: "/ControlPanel/Sliders",
                title: t('Pages.UserControl.sliders'),
                icon: "fal fa-image-polaroid",
                category: "admin_content"
            });
            items.push({
                to: "/ControlPanel/SchoolRank",
                title: t('Pages.UserControl.SchoolRank'),
                icon: "fal fa-trophy-alt",
                category: "admin_users"
            });
            items.push({
                to: "/ControlPanel/StudentRank",
                title: t('Pages.UserControl.StudentRank'),
                icon: "fal fa-medal",
                category: "admin_users"
            });
            items.push({
                to: "/ControlPanel/UserRank",
                title: t('Pages.UserControl.UserRank'),
                icon: "fal fa-award",
                category: "admin_users"
            });
            items.push({
                to: "/ControlPanel/Statistics",
                title: t('Pages.UserControl.CountStatistics'),
                icon: "fal fa-user-chart",
                category: "admin_statistics"
            });
            items.push({
                to: "/ControlPanel/Statistics/Lessons",
                title: t('Pages.UserControl.LessonsStatistics'),
                icon: "fal fa-chart-mixed",
                category: "admin_statistics"
            });
            items.push({
                to: "/ControlPanel/Competition/Statistics",
                title: t('Pages.UserControl.CompetitionStatistics'),
                icon: "fal fa-chart-scatter-bubble",
                category: "admin_statistics"
            });
            items.push({
                to: "/ControlPanel/DeepSeek",
                title: t('Pages.UserControl.DeepSeekAdmin') || "إدارة استهلاك DeepSeek",
                icon: "fal fa-brain",
                category: "admin_statistics"
            });
            items.push({
                to: "/ControlPanel/EmailContent",
                title: t('Pages.UserControl.EmailContent'),
                icon: "fal fa-mail-bulk",
                category: "admin_messaging"
            });
            items.push({
                to: "/User/UserGuide",
                title: t('Pages.UserControl.UserGuide'),
                icon: "fal fa-file-magnifying-glass",
                category: "admin_content"
            });
            items.push({
                to: "/ControlPanel/QuestionsView",
                title: t('Pages.UserControl.QuestionsView'),
                icon: "fal fa-question-circle",
                category: "admin_content"
            });
        }

        if (isParent || isSchool) {
            const isIsraelPalestine = (location && location.location && (location.location.country_code === "il" || location.location.country_code === "ps")) || (user.user && (user.user.Country === "il" || user.user.Country === "ps"));
            items.push({
                to: isIsraelPalestine ? "/User/Renwal" : "/User/Subscription",
                title: user.user.ActivateUntilDate !== "0" ? t('Pages.Profile.services.renewal') : t('Pages.Profile.services.active'),
                icon: "fal fa-money-bill-alt",
                category: "user_parent"
            });
        }

        if (isParent) {
            items.push({
                to: "/User/SubUsers",
                title: t('Pages.UserControl.subUsers'),
                icon: "fal fa-users",
                category: "user_parent"
            });
            items.push({
                to: "/User/Bills",
                title: t('Pages.UserControl.myBills'),
                icon: "fal fa-file-invoice-dollar",
                category: "user_parent"
            });
        }

        if (isSchool) {
            items.push({
                to: "/ControlPanel/Teachers",
                title: t('Pages.UserControl.teachers'),
                icon: "fal fa-chalkboard-teacher",
                category: "school_teacher"
            });
        }

        if (isSchool || isTeacher) {
            items.push({
                to: "/ControlPanel/ClassRooms",
                title: t('Pages.UserControl.classrooms'),
                icon: "fal fa-users-class",
                category: "school_teacher"
            });
            items.push({
                to: "/ControlPanel/School/Lessons/Statistics",
                title: t('Pages.UserControl.LessonsStatistics'),
                icon: "fal fa-chart-mixed",
                category: "school_teacher"
            });
            items.push({
                to: "/School/Competition",
                title: t('Pages.Competition.Stage'),
                icon: "fal fa-crown",
                category: "school_teacher"
            });
            items.push({
                to: "/ControlPanel/Teachers/Statistics",
                title: t('Pages.UserControl.TeacherReport'),
                icon: "fal fa-chart-bar",
                category: "school_teacher"
            });
            items.push({
                to: "/Competition/Statistics",
                title: t('Pages.UserControl.CompetitionStatistics'),
                icon: "fal fa-chart-scatter-bubble",
                category: "school_teacher"
            });
            items.push({
                to: "/ControlPanel/School/Statistics",
                title: t('Pages.UserControl.statistics'),
                icon: "fal fa-user-chart",
                category: "school_teacher"
            });
            items.push({
                to: "/ControlPanel/School/StudentRank",
                title: t('Pages.UserControl.StudentRank'),
                icon: "fal fa-medal",
                category: "school_teacher"
            });
            items.push({
                to: "/ControlPanel/Missions",
                title: t('Pages.UserControl.Missions'),
                icon: "fal fa-bullseye-arrow",
                category: "school_teacher"
            });
            items.push({
                to: "/ControlPanel/Shared/Lessons/",
                title: t('Pages.UserControl.SharedLessons'),
                icon: "fal fa-mind-share",
                category: "school_teacher"
            });
            items.push({
                to: "/ControlPanel/Shared/Files/",
                title: t('Pages.UserControl.SharedFiles'),
                icon: "fal fa-head-side-brain",
                category: "school_teacher"
            });
        }

        if (isStudent) {
            items.push({
                to: "/Student/Competition",
                title: t('Pages.Competition.Stage'),
                icon: "fal fa-crown",
                category: "student"
            });
            items.push({
                to: "/Student/Missions",
                title: t('Pages.UserControl.MyMissions'),
                icon: "fal fa-bullseye-arrow",
                category: "student"
            });
        }

        if (isLoggedIn) {
            items.push({
                to: "/Profile",
                title: t('Pages.Profile.title'),
                icon: "fal fa-user",
                category: "personal"
            });
            items.push({
                to: "/Profile/Edit",
                title: t('edit'),
                icon: "fal fa-edit",
                category: "personal"
            });
            items.push({
                to: "/Profile/Picture",
                title: t('ChangePicture'),
                icon: "fal fa-image",
                category: "personal"
            });
            items.push({
                to: "/Profile/ChangePassword",
                title: t('ChangePassword'),
                icon: "fal fa-key",
                category: "personal"
            });
            items.push({
                to: "/User/Mark",
                title: t('Pages.Profile.markList'),
                icon: "fal fa-trophy-alt",
                category: "personal"
            });
            items.push({
                to: "/User/Favorite/Lesson",
                title: t('Pages.Profile.favoriteList'),
                icon: "fal fa-heart",
                category: "personal"
            });
            items.push({
                to: "/User/Favorite/Files",
                title: t('Pages.Profile.favoriteFiles'),
                icon: "fal fa-heart-circle",
                category: "personal"
            });
            items.push({
                to: "/User/History/Lessons",
                title: t('Pages.Profile.lessonsHistory'),
                icon: "fal fa-history",
                category: "personal"
            });
            items.push({
                to: "/User/History/Files",
                title: t('Pages.Profile.filesHistory'),
                icon: "fal fa-file-arrow-down",
                category: "personal"
            });
        }

        return items;
    }

    getCategoryGradient = (category) => {
        switch (category) {
            case "admin_users":
            case "admin_content":
            case "admin_messaging":
            case "admin_statistics":
            case "admin_billing":
                return "linear-gradient(135deg, #a78bfa, #6366f1)";
            case "school_teacher":
                return "linear-gradient(135deg, #34d399, #059669)";
            case "user_parent":
                return "linear-gradient(135deg, #60a5fa, #0891b2)";
            case "student":
                return "linear-gradient(135deg, #fbbf24, #ea580c)";
            case "personal":
                return "linear-gradient(135deg, #f472b6, #e11d48)";
            default:
                return "linear-gradient(135deg, #94a3b8, #475569)";
        }
    }

    getCategoryBorderColor = (catId) => {
        switch (catId) {
            case 'admin_users': return '#92278f';
            case 'admin_content': return '#8dc53e';
            case 'admin_messaging': return '#00bdff';
            case 'admin_statistics': return '#ff5200';
            case 'admin_billing': return '#e01a1f';
            case 'school_teacher': return '#8dc53e';
            case 'user_parent': return '#00bdff';
            case 'student': return '#ff5200';
            case 'personal': return '#e01a1f';
            default: return '#00a884';
        }
    }

    getCategoryIcon = (catId) => {
        switch (catId) {
            case 'admin_users': return 'fal fa-users-cog';
            case 'admin_content': return 'fal fa-book-open';
            case 'admin_messaging': return 'fal fa-comments-alt';
            case 'admin_statistics': return 'fal fa-chart-line';
            case 'admin_billing': return 'fal fa-file-invoice-dollar';
            case 'school_teacher': return 'fal fa-school';
            case 'user_parent': return 'fal fa-user-friends';
            case 'student': return 'fal fa-graduation-cap';
            case 'personal': return 'fal fa-user-circle';
            default: return 'fal fa-folder';
        }
    }

    render() {
        const { t, user, notifications, location } = this.props;
        const items = this.getControlItems(t, user, notifications, location);

        // Add the original index to each item to preserve its color styling
        const itemsWithOriginalIndex = items.map((item, idx) => ({
            ...item,
            originalIndex: idx
        }));

        const totalNotificationsCount = items.reduce((acc, item) => acc + (item.notification || 0), 0);

        const filteredItems = itemsWithOriginalIndex.filter(item => {
            const matchesSearch = !this.state.searchQuery || (item.title && item.title.toLowerCase().includes(this.state.searchQuery.toLowerCase()));
            const matchesNotification = !this.state.showNotificationsOnly || (item.notification && item.notification > 0);
            return matchesSearch && matchesNotification;
        });

        const categories = [
            { id: "admin_users", name: t('Pages.UserControl.Categories.AdminUsers') || 'إدارة الحسابات والمدارس' },
            { id: "admin_content", name: t('Pages.UserControl.Categories.AdminContent') || 'إدارة المحتوى والمناهج' },
            { id: "admin_messaging", name: t('Pages.UserControl.Categories.AdminMessaging') || 'قنوات التواصل والمراسلة' },
            { id: "admin_statistics", name: t('Pages.UserControl.Categories.AdminStatistics') || 'التقارير والإحصائيات العامة' },
            { id: "admin_billing", name: t('Pages.UserControl.Categories.AdminBilling') || 'الفوترة والدعم الفني' },
            { id: "school_teacher", name: t('Pages.UserControl.Categories.SchoolTeacher') || 'المدرسة والمعلمون' },
            { id: "user_parent", name: t('Pages.UserControl.Categories.ParentSubUsers') || 'الاشتراك والأبناء' },
            { id: "student", name: t('Pages.UserControl.Categories.Student') || 'أدوات الطالب' },
            { id: "personal", name: t('Pages.UserControl.Categories.Personal') || 'حسابي الشخصي' }
        ];

        const colorStyles = `
            .featured-block.color-index-1 .inner-box h5 { color: #8dc53e !important; }
            .featured-block.color-index-1 .inner-box .icon-box { background-color: #8dc53e !important; }
            .featured-block.color-index-1 .inner-box .border-one::before,
            .featured-block.color-index-1 .inner-box .border-one::after,
            .featured-block.color-index-1 .inner-box .border-two::before,
            .featured-block.color-index-1 .inner-box .border-two::after { background-color: #8dc53e !important; }

            .featured-block.color-index-2 .inner-box h5 { color: #e01a1f !important; }
            .featured-block.color-index-2 .inner-box .icon-box { background-color: #e01a1f !important; }
            .featured-block.color-index-2 .inner-box .border-one::before,
            .featured-block.color-index-2 .inner-box .border-one::after,
            .featured-block.color-index-2 .inner-box .border-two::before,
            .featured-block.color-index-2 .inner-box .border-two::after { background-color: #e01a1f !important; }

            .featured-block.color-index-3 .inner-box h5 { color: #ff5200 !important; }
            .featured-block.color-index-3 .inner-box .icon-box { background-color: #ff5200 !important; }
            .featured-block.color-index-3 .inner-box .border-one::before,
            .featured-block.color-index-3 .inner-box .border-one::after,
            .featured-block.color-index-3 .inner-box .border-two::before,
            .featured-block.color-index-3 .inner-box .border-two::after { background-color: #ff5200 !important; }

            .featured-block.color-index-4 .inner-box h5 { color: #92278f !important; }
            .featured-block.color-index-4 .inner-box .icon-box { background-color: #92278f !important; }
            .featured-block.color-index-4 .inner-box .border-one::before,
            .featured-block.color-index-4 .inner-box .border-one::after,
            .featured-block.color-index-4 .inner-box .border-two::before,
            .featured-block.color-index-4 .inner-box .border-two::after { background-color: #92278f !important; }

            .featured-block.color-index-5 .inner-box h5 { color: #0e2c53 !important; }
            .featured-block.color-index-5 .inner-box .icon-box { background-color: #0e2c53 !important; }
            .featured-block.color-index-5 .inner-box .border-one::before,
            .featured-block.color-index-5 .inner-box .border-one::after,
            .featured-block.color-index-5 .inner-box .border-two::before,
            .featured-block.color-index-5 .inner-box .border-two::after { background-color: #0e2c53 !important; }

            .featured-block.color-index-6 .inner-box h5 { color: #187bff !important; }
            .featured-block.color-index-6 .inner-box .icon-box { background-color: #187bff !important; }
            .featured-block.color-index-6 .inner-box .border-one::before,
            .featured-block.color-index-6 .inner-box .border-one::after,
            .featured-block.color-index-6 .inner-box .border-two::before,
            .featured-block.color-index-6 .inner-box .border-two::after { background-color: #187bff !important; }

            .featured-block.color-index-7 .inner-box h5 { color: #ffb100 !important; }
            .featured-block.color-index-7 .inner-box .icon-box { background-color: #ffb100 !important; }
            .featured-block.color-index-7 .inner-box .border-one::before,
            .featured-block.color-index-7 .inner-box .border-one::after,
            .featured-block.color-index-7 .inner-box .border-two::before,
            .featured-block.color-index-7 .inner-box .border-two::after { background-color: #ffb100 !important; }

            .featured-block.color-index-8 .inner-box h5 { color: #00bdff !important; }
            .featured-block.color-index-8 .inner-box .icon-box { background-color: #00bdff !important; }
            .featured-block.color-index-8 .inner-box .border-one::before,
            .featured-block.color-index-8 .inner-box .border-one::after,
            .featured-block.color-index-8 .inner-box .border-two::before,
            .featured-block.color-index-8 .inner-box .border-two::after { background-color: #00bdff !important; }

            .featured-block.color-index-9 .inner-box h5 { color: #f30f8d !important; }
            .featured-block.color-index-9 .inner-box .icon-box { background-color: #f30f8d !important; }
            .featured-block.color-index-9 .inner-box .border-one::before,
            .featured-block.color-index-9 .inner-box .border-one::after,
            .featured-block.color-index-9 .inner-box .border-two::before,
            .featured-block.color-index-9 .inner-box .border-two::after { background-color: #f30f8d !important; }

            .featured-block.color-index-10 .inner-box h5 { color: #5d35ff !important; }
            .featured-block.color-index-10 .inner-box .icon-box { background-color: #5d35ff !important; }
            .featured-block.color-index-10 .inner-box .border-one::before,
            .featured-block.color-index-10 .inner-box .border-one::after,
            .featured-block.color-index-10 .inner-box .border-two::before,
            .featured-block.color-index-10 .inner-box .border-two::after { background-color: #5d35ff !important; }
        `;

        const isSearching = !!this.state.searchQuery;
        const showSidebar = this.state.viewMode === 'categorized' && !isSearching;

        return (
            <>
                <Helmet>
                    <title>
                        {t('Pages.UserControl.title')} | {t('alarabeyya')}
                    </title>
                </Helmet>
                <style dangerouslySetInnerHTML={{ __html: colorStyles }} />

                <section className="position-relative padding-bottom padding-top " id="main-dashboard-section" style={{
                    minHeight: '100vh'
                }}>
                    <DashBoardBg user={user} />

                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-12 mb-50">

                                <div className="row justify-content-center">
                                    <div className="col-lg-8">
                                        <div className="section-header text-center">
                                            <h3 className="title">{t('Pages.UserControl.title')}</h3>
                                        </div>
                                    </div>
                                </div>

                                {/* View Mode Toggle & Notifications Filter Row */}
                                <div className="row justify-content-center mb-4 align-items-center" style={{ gap: '15px' }}>
                                    <div className="col-auto">
                                        <div className="view-mode-toggle-container d-inline-flex">
                                            <button
                                                type="button"
                                                className={this.state.viewMode === 'categorized' ? 'active' : 'inactive'}
                                                onClick={() => this.setState({ viewMode: 'categorized' })}
                                            >
                                                <i className="fal fa-folders ml-2"></i>
                                                {t('Pages.UserControl.Categories.Grouped') || "تصنيف حسب المجموعات"}
                                            </button>
                                            <button
                                                type="button"
                                                className={this.state.viewMode === 'classic' ? 'active' : 'inactive'}
                                                onClick={() => this.setState({ viewMode: 'classic' })}
                                            >
                                                <i className="fal fa-th ml-2"></i>
                                                {t('Pages.UserControl.Categories.Classic') || "عرض الكل"}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            type="button"
                                            className={`notifications-only-filter-btn ${this.state.showNotificationsOnly ? 'active' : 'inactive'}`}
                                            onClick={() => this.setState(prevState => ({ showNotificationsOnly: !prevState.showNotificationsOnly }))}
                                        >
                                            <i className="fal fa-bell ml-2"></i>
                                            {t('Pages.UserControl.showNotificationsOnly') || "الإشعارات فقط"}
                                            {totalNotificationsCount > 0 && (
                                                <span className="badge badge-danger mr-2" style={{ borderRadius: '10px', fontSize: '11px', padding: '3px 8px' }}>
                                                    {totalNotificationsCount}
                                                </span>
                                            )}
                                        </button>
                                    </div>
                                </div>

                                {/* Modern Search Bar */}
                                <div className="row justify-content-center mb-5">
                                    <div className="col-md-6 col-sm-10">
                                        <div
                                            style={{
                                                position: 'relative',
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: 'rgba(255, 255, 255, 0.9)',
                                                border: '1px solid rgba(0, 0, 0, 0.08)',
                                                borderRadius: '30px',
                                                padding: '4px 20px',
                                                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.04)',
                                                backdropFilter: 'blur(10px)',
                                                WebkitBackdropFilter: 'blur(10px)'
                                            }}
                                        >
                                            <i className="fal fa-search text-muted ml-3" style={{ fontSize: '18px', color: '#94a3b8' }}></i>
                                            <input
                                                type="text"
                                                className="form-control text-right"
                                                placeholder={t('Pages.UserControl.search') || "البحث عن الأقسام أو الأدوات..."}
                                                value={this.state.searchQuery}
                                                onChange={e => this.setState({ searchQuery: e.target.value })}
                                                style={{
                                                    border: 'none',
                                                    background: 'transparent',
                                                    boxShadow: 'none',
                                                    outline: 'none',
                                                    padding: '10px 0',
                                                    fontSize: '15px',
                                                    fontFamily: 'Cairo, sans-serif',
                                                    color: '#1e293b',
                                                    width: '100%'
                                                }}
                                            />
                                            {this.state.searchQuery && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link text-muted p-0 mr-3"
                                                    onClick={() => this.setState({ searchQuery: "" })}
                                                    style={{ width: 'auto', border: 'none', background: 'transparent' }}
                                                >
                                                    <i className="fal fa-times-circle"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="dashboard-layout">
                                    {/* Sidebar Column (Desktop right sidebar, mobile top chips) */}
                                    {showSidebar && (
                                        <div className="dashboard-sidebar">
                                            <div className="sidebar-nav-card p-4">
                                                <h5 className="sidebar-title font-weight-bold">{t('Pages.UserControl.Categories.MenuTitle') || "أقسام لوحة التحكم"}</h5>
                                                <div className="nav flex-column nav-pills" role="tablist">
                                                    <button
                                                        type="button"
                                                        className={`nav-link ${this.state.activeCategory === 'all' ? 'active' : ''}`}
                                                        onClick={() => this.setState({ activeCategory: 'all' })}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <i className="fal fa-th-large ml-2" style={{ fontSize: '16px' }}></i>
                                                            <span>{t('Pages.UserControl.Categories.All') || "جميع الأقسام"}</span>
                                                        </div>
                                                        <span className="badge badge-secondary">{filteredItems.length}</span>
                                                    </button>

                                                    {categories.map(cat => {
                                                        const catItems = filteredItems.filter(item => item.category === cat.id);
                                                        if (catItems.length === 0) return null;
                                                        const isActive = this.state.activeCategory === cat.id;
                                                        const borderColor = this.getCategoryBorderColor(cat.id);

                                                        return (
                                                            <button
                                                                key={cat.id}
                                                                type="button"
                                                                className={`nav-link ${isActive ? 'active' : ''}`}
                                                                style={isActive ? { borderRight: `4px solid ${borderColor}`, background: 'rgba(0, 168, 132, 0.08)', color: '#008069' } : {}}
                                                                onClick={() => this.setState({ activeCategory: cat.id })}
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <i className={`${this.getCategoryIcon(cat.id)} ml-2`} style={{ fontSize: '16px', color: isActive ? '#008069' : '#64748b' }}></i>
                                                                    <span>{cat.name}</span>
                                                                </div>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: isActive ? '#00a884' : '#e2e8f0',
                                                                        color: isActive ? '#fff' : '#475569'
                                                                    }}
                                                                >
                                                                    {catItems.length}
                                                                </span>
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Main Content Area */}
                                    <div className="dashboard-content">
                                        {isSearching ? (
                                            /* Search Results View */
                                            <div className="category-section mb-5 w-100 animate__animated animate__fadeIn">
                                                <div className="d-flex align-items-center justify-content-between mb-4 p-3 category-header-card">
                                                    <h4 className="category-title m-0 text-right font-weight-bold" style={{ fontSize: '18px' }}>
                                                        {t('Pages.UserControl.SearchResult') || "نتائج البحث"}
                                                    </h4>
                                                    <span className="badge badge-success" style={{ borderRadius: '12px', fontSize: '13px', padding: '5px 12px', fontWeight: 'bold', backgroundColor: '#00a884' }}>
                                                        {filteredItems.length}
                                                    </span>
                                                </div>
                                                <div className="row clearfix justify-content-start">
                                                    {filteredItems.map((item, idx) => {
                                                        const colorIndex = (item.originalIndex % 10) + 1;
                                                        return (
                                                            <Link key={idx} to={item.to} className={`featured-block col-lg-3 col-md-4 col-sm-6 text-decoration-none mb-4 color-index-${colorIndex} cat-${item.category}`} title={item.title}>
                                                                <div className="inner-box wow fadeInLeft animated h-100">
                                                                    {item.notification ? this.renderNotification(item.notification) : null}
                                                                    <span className="border-one"></span>
                                                                    <span className="border-two"></span>
                                                                    <div className="icon-box d-flex justify-content-center flex-column">
                                                                        <span className="icon"> <i className={`${item.icon} h3 mb-0 text-white`}></i></span>
                                                                    </div>
                                                                    <h5>{item.title}</h5>
                                                                </div>
                                                            </Link>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ) : this.state.viewMode === 'categorized' ? (
                                            /* Grouped Categories View */
                                            categories.map(cat => {
                                                if (this.state.activeCategory !== 'all' && this.state.activeCategory !== cat.id) return null;
                                                const catItems = filteredItems.filter(item => item.category === cat.id);
                                                if (catItems.length === 0) return null;
                                                const borderColor = this.getCategoryBorderColor(cat.id);

                                                return (
                                                    <div key={cat.id} className="category-section mb-5 w-100 animate__animated animate__fadeIn">
                                                        <div className="d-flex align-items-center justify-content-between mb-4 p-3 category-header-card" style={{ borderRight: `5px solid ${borderColor}` }}>
                                                            <h4 className="category-title m-0 text-right font-weight-bold" style={{ fontSize: '18px' }}>
                                                                {cat.name}
                                                            </h4>
                                                            <span className="badge" style={{ backgroundColor: borderColor, color: '#fff', borderRadius: '12px', fontSize: '13px', padding: '5px 12px', fontWeight: 'bold' }}>
                                                                {catItems.length}
                                                            </span>
                                                        </div>
                                                        <div className="row clearfix justify-content-start">
                                                            {catItems.map((item, idx) => {
                                                                const colorIndex = (item.originalIndex % 10) + 1;
                                                                return (
                                                                    <Link key={idx} to={item.to} className={`featured-block col-lg-3 col-md-4 col-sm-6 text-decoration-none mb-4 color-index-${colorIndex} cat-${item.category}`} title={item.title}>
                                                                        <div className="inner-box wow fadeInLeft animated h-100">
                                                                            {item.notification ? this.renderNotification(item.notification) : null}
                                                                            <span className="border-one"></span>
                                                                            <span className="border-two"></span>
                                                                            <div className="icon-box d-flex justify-content-center flex-column">
                                                                                <span className="icon"> <i className={`${item.icon} h3 mb-0 text-white`}></i></span>
                                                                            </div>
                                                                            <h5>{item.title}</h5>
                                                                        </div>
                                                                    </Link>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            /* Classic Flat view */
                                            <div className="category-section mb-5 w-100 animate__animated animate__fadeIn">
                                                <div className="row clearfix justify-content-start">
                                                    {filteredItems.map((item, idx) => {
                                                        const colorIndex = (item.originalIndex % 10) + 1;
                                                        return (
                                                            <Link key={idx} to={item.to} className={`featured-block col-lg-3 col-md-4 col-sm-6 text-decoration-none mb-4 color-index-${colorIndex} cat-${item.category}`} title={item.title}>
                                                                <div className="inner-box wow fadeInLeft animated h-100">
                                                                    {item.notification ? this.renderNotification(item.notification) : null}
                                                                    <span className="border-one"></span>
                                                                    <span className="border-two"></span>
                                                                    <div className="icon-box d-flex justify-content-center flex-column">
                                                                        <span className="icon"> <i className={`${item.icon} h3 mb-0 text-white`}></i></span>
                                                                    </div>
                                                                    <h5>{item.title}</h5>
                                                                </div>
                                                            </Link>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                        {filteredItems.length === 0 && (
                                            <div className="text-center w-100 my-5">
                                                <p className="text-muted h5">{t('NoInfo') || "لا توجد نتائج"}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        notifications: state.notifications,
        location: state.location
    };
};

export default connect(mapStateToProps, { userInitial })(withTranslation('common')(UserControl));